// Scheda cliente e agenzie dello staff: etichette e piccole regole comuni.

export const STATI_IMMOBILE = [
  ['nuovo', 'Nuovo', 'var(--mute)'],
  ['da_contattare', 'Da contattare', 'var(--warn)'],
  ['visita_richiesta', 'Visita richiesta', 'var(--ok)'],
  ['non_risponde', 'Non risponde', 'var(--warn)'],
  ['richiamare', 'Da richiamare', 'var(--warn)'],
  ['attesa_collega', 'Attesa collega', 'var(--info)'],
  ['attesa_disponibilita', 'Attesa disponibilità', 'var(--warn)'],
  ['da_visionare', 'Da visionare', 'var(--info)'],
  ['visita_fissata', 'Visita fissata', 'var(--ok)'],
  ['proposta_in_corso', 'Proposta in corso', 'var(--brass2)'],
  ['rogito_in_corso', 'Rogito in corso', 'var(--brass2)'],
  ['scartato', 'Scartato', 'var(--mute)'],
];
export const statoImmobile = (chiave) => STATI_IMMOBILE.find((s) => s[0] === chiave) || STATI_IMMOBILE[0];

export const MOTIVI_SCARTO = [
  ['prezzo_alto', 'Prezzo troppo alto'], ['zona_non_adatta', 'Zona non adatta'], ['condizioni_immobile', "Condizioni dell'immobile"],
  ['metratura_inadeguata', 'Metratura inadeguata'], ['piano_non_adatto', 'Piano non adatto'], ['mancanza_requisiti', 'Mancanza requisiti'],
  ['agenzia_non_collaborativa', 'Agenzia non collaborativa'], ['gia_venduto', 'Immobile già venduto'],
  ['cliente_non_interessato', 'Cliente non più interessato'], ['altro', 'Altro motivo'],
];

// La dichiarazione: la conferma formale dell'agenzia di collaborare con noi (agenzie.stato_dichiarato + data_dichiarazione).
// classe: colore del testo (ok verde, w arancio, no rosso; mai "r", che nello stile dello staff è l'animazione d'entrata)
export const DICHIARAZIONI = {
  dichiarato: { testo: 'Dichiarato ✓', breve: 'Dichiarate', classe: 'ok', colore: 'var(--ok)' },
  in_attesa_dichiarazione: { testo: 'In attesa dichiarazione', breve: 'In attesa', classe: 'w', colore: 'var(--warn)' },
  non_dichiarato: { testo: 'Non dichiarato', breve: 'Non dichiarano', classe: 'no', colore: 'var(--bad)' },
};
// L'agenzia accanto a una casa o a un annuncio (Nuovi annunci, Case in archivio, riquadro dell'immobile): quello che
// conta è la DICHIARAZIONE, non la collaborazione. È anche quello che pesa sul punteggio (backend/corrispondenza.py:
// dichiarata +30, non dichiara -25; «in attesa» non toglie e non aggiunge). La collaborazione (lavorabile / non
// lavorabile) è un giudizio nostro e resta solo nella scheda dell'agenzia, come dato secondario.
export const STATI_DICHIARAZIONE = {
  dichiarata: { testo: 'Dichiarata ✓', classe: 'ok', colore: 'var(--ok)' },
  in_attesa: { testo: 'In attesa', classe: 'w', colore: 'var(--warn)' },
  non_dichiara: { testo: 'Non dichiara', classe: 'no', colore: 'var(--bad)' },
  // l'agenzia scritta sull'annuncio e mai vista prima: non ha una scheda, quindi non ha nemmeno una dichiarazione
  nuova: { testo: 'nuova, mai vista', classe: 'n', colore: 'var(--info)' },
};
// I nomi che arrivano dal server, nuovi e vecchi, portati sulle stesse etichette. Chi collabora ma non ha dichiarato
// è «In attesa»: collaborare non è dichiarare.
const ALIAS_DICHIARAZIONE = {
  dichiarata: 'dichiarata', dichiarato: 'dichiarata',
  in_attesa: 'in_attesa', in_attesa_dichiarazione: 'in_attesa', collaborante: 'in_attesa', collabora: 'in_attesa', lavorabile: 'in_attesa',
  non_dichiara: 'non_dichiara', non_dichiarato: 'non_dichiara', non_collabora: 'non_dichiara', non_lavorabile: 'non_dichiara',
  nuova: 'nuova',
};
export const dichiarazioneAgenzia = (stato) => STATI_DICHIARAZIONE[ALIAS_DICHIARAZIONE[stato] || 'in_attesa'];

// Il logo dell'agenzia quando manca: l'iniziale del nome
export const inizialeAgenzia = (nome) => (String(nome || '').replace(/[^\p{L}\p{N}]/gu, '').charAt(0) || '?').toUpperCase();
export const COLLABORAZIONI = {
  lavorabile: { testo: 'Collabora', classe: 'ok', colore: 'var(--ok)' },
  in_attesa: { testo: 'In attesa', classe: 'w', colore: 'var(--warn)' },
  non_lavorabile: { testo: 'Non collabora', classe: 'n', colore: 'var(--bad)' },
};

export const LINGUE = [['it', 'italiano'], ['ru', 'russo'], ['uk', 'ucraino'], ['en', 'inglese'], ['ro', 'rumeno']];

export const euro = (valore) => {
  if (valore === null || valore === undefined || valore === '') return null;
  const n = typeof valore === 'number' ? valore : Number(String(valore).replace(/[^\d,]/g, '').replace(',', '.'));
  if (!n) return typeof valore === 'string' ? valore : null;
  return `${Math.round(n).toLocaleString('it-IT')} €`;
};

// "Oleksandr M." → "O"; per il feed: chi ha fatto la cosa
export const inizialeChi = (chi) => (chi?.iniziale || '?');

// Le offerte in fila: "Offerta 362.000 € → Controproposta 375.000 € → Nuova offerta 368.000 € → Accettata"
const NOMI_OFFERTE = { offerta: 'Offerta', controproposta: 'Controproposta', rilancio: 'Nuova offerta', accettata: 'Accettata', rifiutata: 'Rifiutata' };
export const passiOfferte = (storico = []) => storico.map((o) => ({
  testo: NOMI_OFFERTE[o.tipo] || o.tipo, prezzo: ['accettata', 'rifiutata'].includes(o.tipo) ? null : euro(o.prezzo),
  classe: o.tipo === 'controproposta' ? 'loro' : o.tipo === 'accettata' ? 'ok' : o.tipo === 'rifiutata' ? 'no' : 'nostra',
  data: o.data,
}));

// Elenco agenzie: filtri della pagina (dichiarazione, collaborazione, marchio, comune, altro, ricerca)
export const filtraAgenzie = (agenzie, f) => agenzie.filter((a) => {
  if (f.dichiarazione && a.dichiarazione !== f.dichiarazione) return false;
  if (f.collaborazione && a.collaborazione !== f.collaborazione) return false;
  if (f.marchio && a.marchio !== f.marchio) return false;
  if (f.comune && a.comune !== f.comune) return false;
  if (f.altro === 'attivi' && !(a.con_noi?.attivi > 0)) return false;
  if (f.altro === 'incomplete' && !(a.mancano || []).length) return false;
  if (f.cerca) {
    const t = f.cerca.toLowerCase();
    const dove = [a.nome, a.etichetta, a.comune, a.marchio, a.referente?.nome, a.telefono].filter(Boolean).join(' ').toLowerCase();
    if (!dove.includes(t)) return false;
  }
  return true;
});

export const NOMI_MANCANTI = { comune: 'comune', telefono: 'telefono', logo: 'logo', id_portale: 'pagina sul portale' };
export const testoMancano = (mancano = []) => {
  const nomi = mancano.map((m) => NOMI_MANCANTI[m] || m);
  if (!nomi.length) return '';
  return `${nomi.length === 1 ? nomi[0] : `${nomi.slice(0, -1).join(', ')} e ${nomi[nomi.length - 1]}`} ${nomi.length === 1 ? 'mancante' : 'mancanti'}`;
};

// Home del cliente: la proposta aperta che scade per prima (entro 30 giorni), con l'immobile
export const scadenzaProposta = (proposte = [], immobili = [], adesso = new Date()) => {
  const oggi = new Date(adesso.getFullYear(), adesso.getMonth(), adesso.getDate());
  const aperte = proposte
    .filter((p) => ['inviata', 'in_negoziazione'].includes(p.stato) && p.data_scadenza)
    .map((p) => ({ p, scade: new Date(String(p.data_scadenza).slice(0, 10) + 'T00:00:00') }))
    .filter(({ scade }) => scade >= oggi && (scade - oggi) / 86400000 <= 30)
    .sort((a, b) => a.scade - b.scade);
  if (!aperte.length) return null;
  const { p, scade } = aperte[0];
  const imm = immobili.find((i) => i.id === p.immobile_id) || {};
  return { proposta: p, scade, dove: imm.indirizzo || imm.titolo || "l'immobile", immobileId: imm.id, giorni: Math.round((scade - oggi) / 86400000) };
};
